import { BookingExportOption } from "./booking-export-option";
import { SearchRule } from "./search-rule";

export class CustomCsvExportConfiguration {

    constructor(
        public searchRules: SearchRule[],
        public exportOptions: BookingExportOption[]
    ){}
}
